<template>
  <div>
    <detail-card :data="order" type="order" v-bind="$attrs">
      <template v-slot:header>{{ order.number }}</template>
      <template v-slot:body>
        <prop name="Nummer">
          {{ order.number }}
        </prop>
        <prop name="erstellt">
          {{ order.createdTime | dateTime }}
        </prop>
        <ref :id="order.customer.id" type="customer">{{ order.customer.name }}</ref>
        <prop name="Status">
              <span v-for="state in states"
                    :key="state"
                    class="badge p-1 mr-1"
                    :class="{'badge-success': state === order.state, 'badge-light': state !== order.state}">
          {{ stateInGerman(state) }}</span>
        </prop>
        <prop name="Total" v-if="!changingTotalGrossPrice">
          {{ order.totalGrossPrice | price }}
          <font-awesome-icon :icon="['far', 'edit']" class="fa-edit ml-2 link" fixed-width size="1x"
                             @click="changingTotalGrossPrice = true"/>
        </prop>
        <prop v-else name="Total">
          <div class="d-flex">
            <input class="form-control" type="number" v-model="changedTotalGrossPrice"/>
          </div>
          <div class="mt-1">
            <button class="btn btn-sm btn-danger"
                    @click="changingTotalGrossPrice = false">
              Abbrechen
            </button>
            <button class="btn btn-sm btn-success ml-1" @click="changeTotalGrossPrice">Speichern</button>
          </div>
        </prop>
        <prop name="Discount">{{ order.totalGrossDiscount | price }}</prop>
        <prop name="Netto">{{ order.totalGrossPrice - order.totalVat | price }}</prop>
        <prop name="USt.">{{ order.totalVat | price }}</prop>
        <prop name="Positionen">
          <div v-for="(position) in order.positions"
               :key="position.id">
            <div class="d-flex">
              <div>{{ position.quantity }}&times;</div>
              <div class="flex-fill">{{ position.article.product.name }}</div>
            </div>
          </div>
        </prop>
        {{ usedVoucher ? usedVoucher.number : '-' }}
        <ref name="benutzter Gutschein" type="voucher" :id="usedVoucher.code">
          {{ usedVoucher ? usedVoucher.code : '-' }}
        </ref>
        <prop v-if="order.reservation" name="Reservierung">
          {{ order.reservation.startTime | shortDateTime }}
          <button class="ml-2 btn btn-sm btn-primary" @click="switchReservationModalOpen = true">Ändern</button>
        </prop>
        <prop v-if="relatedOrders.length > 0" name="zug. Bestellungen">
          <div v-for="relatedOrder in relatedOrders" :key="relatedOrder.id">
            <router-link :to="{name: 'orderDetail', params: {id: relatedOrder.id}}">{{relatedOrder.number}}</router-link>
          </div>
        </prop>
      </template>
    </detail-card>
    <modal class="position-absolute shadow" title="Reservierung der Bestellung ändern"
           v-if="switchReservationModalOpen"
           @close="switchReservationModalOpen = false">
      <template v-slot:body>
        <SwitchReservation :orderId="order.id"/>
      </template>
    </modal>
  </div>
</template>

<script>
import {DateTime} from 'luxon'
import DetailCard from "@/layouts/DetailCard";
import Prop from "@/layouts/Prop";
import Ref from "@/layouts/Ref";
import SwitchReservation from '@/components/order/SwitchReservation.vue'
import Modal from "@/layouts/Modal";

export default {
  components: {SwitchReservation, Ref, Prop, DetailCard, Modal},
  props: {
    order: Object,
  },
  data() {
    return {
      states: ['created', 'toBeFulfilled', 'fulfilled', 'canceled'],
      blockPostFulfillmentCommunication: false,
      usedVoucher: null,
      switchReservationModalOpen: false,
      relatedOrders: [],
      changingTotalGrossPrice: false,
      changedTotalGrossPrice: 0
    }
  },
  computed: {
    reservationTime() {
      return DateTime.fromJSDate(new Date(this.order.startTime))
    }
  },
  methods: {
    stateInGerman(state) {
      if (state === 'canceled')
        return 'abgebrochen'
      if (state === 'fulfilled')
        return 'geleistet'
      if (state === 'toBeFulfilled')
        return 'wartet auf Leistung'
      return 'erstellt'
    },
    async changeTotalGrossPrice(){
      await this.$api.put(`/orders/${this.order.id}/total-gross-price`, {totalGrossPrice: this.changedTotalGrossPrice})
          .then(() => this.$router.go(0))
          .catch(err => this.handleError(err))
      this.changingTotalGrossPrice = false;
    }
  },
  watch: {
    order: {
      handler(newVal) {
        if (newVal?.id) {
          this.$api.get(`/vouchers`, {
            params: {
              usedIn: this.order.id
            }
          }).then(res => this.usedVoucher = {...res.data, id: res.data.code})
              .catch(err => this.handleError(err))
          this.$api.get(`/orders/${newVal.id}/related`)
              .then(res => this.relatedOrders = res.data)
              .catch(err => this.handleError(err))
        } else {
          this.usedVoucher = null
        }
        this.changedTotalGrossPrice = newVal.totalGrossPrice
      },
      immediate: true
    }
  }
}
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
